module.exports = __webpack_public_path__ + "img/banner-panels.6f0f835e.svg";